import { Button } from "@mui/material"
import { useState } from "react"
import AddRoundedIcon from "@mui/icons-material/AddRounded"
import AddStudent from "../modals/AddStudent"
import { getAllStudents, getProgramStudents, getStudentFilters, getStudentSort } from "../../api"
import { AuthorizedFor } from "../common/AuthorizedFor"
import roles from "../../constants/roles"
import ListData from "../common/ListData"
import StudentCard from "../cards/StudentCard"

const StudentsTab = ({ batchData, programData, admissionData }) => {
  const [addStudentModal, setAddStudentModal] = useState(false)
  // const [search, setSearch] = useState("")
  // const handleSearchChange = (event) => setSearch(event.target.value)

  const CTA = () => (
    <AuthorizedFor roles={[roles.ADMIN, roles.STAFF]}>
      <Button
        onClick={() => setAddStudentModal(true)}
        variant="contained"
        startIcon={<AddRoundedIcon />}
      >
        Add Student
      </Button>
    </AuthorizedFor>
  )

  return (
    <>
      {/* <TextField
          value={search}
          onChange={handleSearchChange}
          placeholder="Search Students..."
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon />
              </InputAdornment>
            ),
          }}
        /> */}

      <ListData
        getFilters={getStudentFilters}
        getSort={getStudentSort}
        getAllData={getAllStudents}
        initialFilters={programData?.id ? { filter: { programId: programData?.id } } : batchData?.id ? { filter: { batchId: batchData?.id } } : {}}
        HeaderRight={CTA}
        Card={StudentCard}
      />
      <AddStudent
        isOpen={addStudentModal}
        close={() => setAddStudentModal(false)}
        admissionData={admissionData}
      />
    </>
  )
}

export default StudentsTab
